import { __rest } from "tslib";
import * as React from 'react';
import { Title, TitleSizes } from '../Title';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Login/login';
export var LoginMainHeader = function LoginMainHeader(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$title = _a.title,
      title = _a$title === void 0 ? '' : _a$title,
      _a$subtitle = _a.subtitle,
      subtitle = _a$subtitle === void 0 ? '' : _a$subtitle,
      props = __rest(_a, ["children", "className", "title", "subtitle"]);

  return React.createElement("header", Object.assign({
    className: css(styles.loginMainHeader, className)
  }, props), title && React.createElement(Title, {
    headingLevel: "h2",
    size: TitleSizes['3xl']
  }, title), subtitle && React.createElement("p", {
    className: css(styles.loginMainHeaderDesc)
  }, subtitle), children);
};